<template>
    <section>
        <el-form :inline="true" class="toolbar" :model="searchForm">
            <el-form-item label="商户">
                <el-select clearable v-model="searchForm.merchantId" placeholder="请选择商户">
                    <el-option v-for="item in merchantList" :key="item.id" :label="item.merchantName"
                        :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="支付方式" v-show="searchForm.merchantId">
                <el-select clearable v-model="searchForm.accountType" placeholder="请选择">
                    <el-option v-for="(item, index) in accountTypeOptions" :key="index" :label="item" :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button @click="search" type="primary" size="mini">查询</el-button>
                <el-button @click="handleAdd" type="success" size="mini">新增</el-button>
                <el-button @click="handleChannelRankInit" type="success" size="mini">通道排名初始化</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="flattenTableData" border height="650" style="width: 100%" v-loading="loading"
            :span-method="objectSpanMethod">
            <!-- 档位 -->
            <el-table-column align="center" prop="rangeText" label="档位" width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.isFirst">[{{ scope.row.startAmount }}-{{ scope.row.endAmount }})</span>
                </template>
            </el-table-column>
            <!-- 轮询数据范围配置 -->
            <el-table-column align="center" prop="dataRange" label="轮询数据范围配置（近多少单）" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.isFirst">{{ scope.row.dataRange }}</span>
                </template>
            </el-table-column>
            <!-- 轮询数据计算CD -->
            <el-table-column align="center" prop="calCd" label="轮询数据计算CD（每多少单）" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.isFirst">{{ scope.row.calCd }}</span>
                </template>
            </el-table-column>
            <!-- 系统拉单时间 -->
            <el-table-column align="center" prop="systemTime" label="系统拉单时间（每多少分钟）" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.isFirst">{{ scope.row.systemTime }}</span>
                </template>
            </el-table-column>
            <!-- 系统拉单笔数 -->
            <el-table-column align="center" prop="systemNum" label="系统拉单笔数（每通道多少笔）" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.isFirst">{{ scope.row.systemNum }}</span>
                </template>
            </el-table-column>
            <!-- 掉单率范围 -->
            <el-table-column align="center" prop="missRange" label="掉单率范围（近x笔订单）" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.isFirst">{{ scope.row.missRange }}</span>
                </template>
            </el-table-column>
            <!-- 订单拉起率(权重值) -->
            <el-table-column align="center" prop="createWeight" label="订单拉起率(权重值)"></el-table-column>
            <!-- 订单成功率(权重值) -->
            <el-table-column align="center" prop="successWeight" label="订单成功率(权重值)"></el-table-column>
            <!-- 系统拉单成功率(权重值) -->
            <el-table-column align="center" prop="systemWeight" label="系统拉单成功率(权重值)"></el-table-column>
            <!-- 掉单率(权重值) -->
            <el-table-column align="center" prop="missWeight" label="掉单率(权重值)"></el-table-column>
            <!-- 订单拉起率(基准值) -->
            <el-table-column align="center" prop="createBase" label="订单拉起率(基准值)" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.isFirst">{{ scope.row.createBase }}</span>
                </template>
            </el-table-column>
            <!-- 订单成功率(基准值) -->
            <el-table-column align="center" prop="successBase" label="订单成功率(基准值)" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.isFirst">{{ scope.row.successBase }}</span>
                </template>
            </el-table-column>
            <!-- 用户类型 -->
            <el-table-column align="center" prop="userType" label="用户类型" width="100"></el-table-column>
            <!-- 操作 -->
            <el-table-column align="center" label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleEdit(scope.row.rawData)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="handleDelete(scope.row.rawData)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 新增/编辑弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
            <el-form :model="form" label-width="200px" :rules="rules" ref="form">
                <!-- 基础信息 -->
                <el-form-item label="支付方式名称" prop="accountType">
                    <el-select v-model="form.accountType" placeholder="请选择支付方式" style="width: 100%">
                        <el-option v-for="(item, index) in accountTypeOptions" :key="index" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="最低金额(含)" prop="startAmount">
                    <el-input-number v-model="form.startAmount" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="最高金额(不含)" prop="endAmount">
                    <el-input-number v-model="form.endAmount" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="轮询范围(近多少单)" prop="dataRange">
                    <el-input-number v-model="form.dataRange" :min="1" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="轮询计算CD(每多少单)" prop="calCd">
                    <el-input-number v-model="form.calCd" :min="1" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="系统拉单时间(每多少分钟)" prop="systemTime">
                    <el-input-number v-model="form.systemTime" :min="1" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="系统拉单笔数(每通道笔数)" prop="systemNum">
                    <el-input-number v-model="form.systemNum" :min="1" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="掉单率范围(近X笔订单)" prop="missRange">
                    <el-input-number v-model="form.missRange" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>

                <!-- 未付费用户权重 -->
                <el-divider content-position="left">未付费用户权重配置</el-divider>
                <el-form-item label="未付费-订单拉起率(权重值)" prop="createWeight">
                    <el-input-number v-model="form.createWeight" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="未付费-订单成功率(权重值)" prop="successWeight">
                    <el-input-number v-model="form.successWeight" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="未付费-系统拉单成功率(权重值)" prop="systemWeight">
                    <el-input-number v-model="form.systemWeight" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="未付费-掉单率(权重值)" prop="missWeight">
                    <el-input-number v-model="form.missWeight" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>

                <!-- 付费用户权重 -->
                <el-divider content-position="left">付费用户权重配置</el-divider>
                <el-form-item label="付费-订单拉起率(权重值)" prop="payCreateWeight">
                    <el-input-number v-model="form.payCreateWeight" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="付费-订单成功率(权重值)" prop="paySuccessWeight">
                    <el-input-number v-model="form.paySuccessWeight" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="付费-系统拉单成功率(权重值)" prop="paySystemWeight">
                    <el-input-number v-model="form.paySystemWeight" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="付费-掉单率(权重值)" prop="payMissWeight">
                    <el-input-number v-model="form.payMissWeight" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>

                <!-- 基准值 -->
                <el-divider content-position="left">基准值配置</el-divider>
                <el-form-item label="订单拉起率(基准值)" prop="createBase">
                    <el-input-number v-model="form.createBase" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="订单成功率(基准值)" prop="successBase">
                    <el-input-number v-model="form.successBase" :min="0" style="width: 100%"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmit">确定</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
import merchantApi from "@/api/merchantPayConfig/merchantApi";
export default {
    data() {
        return {
            loading: false,
            tableData: [],
            searchForm: {
                merchantId: '',
                accountType: ''
            },
            accountTypeOptions: [],
            merchantList: [],
            channelList: [],
            dialogVisible: false,
            dialogTitle: '新增',
            form: {
                id: null,
                merchantId: '',
                accountType: '',
                startAmount: 0,
                endAmount: 1000,
                dataRange: 100,
                calCd: 50,
                systemTime: 20,
                systemNum: 10,
                missRange: 0,
                createWeight: 0,
                successWeight: 0,
                systemWeight: 0,
                missWeight: 0,
                payCreateWeight: 0,
                paySuccessWeight: 0,
                paySystemWeight: 0,
                payMissWeight: 0,
                createBase: 0,
                successBase: 0
            },
            rules: {
                accountType: [{ required: true, message: '请选择支付方式', trigger: 'change' }],
                startAmount: [{ required: true, message: '请输入最低金额', trigger: 'blur' }],
                endAmount: [{ required: true, message: '请输入最高金额', trigger: 'blur' }],
                dataRange: [{ required: true, message: '请输入轮询范围', trigger: 'blur' }],
                calCd: [{ required: true, message: '请输入轮询计算CD', trigger: 'blur' }],
                systemTime: [{ required: true, message: '请输入系统拉单时间', trigger: 'blur' }],
                systemNum: [{ required: true, message: '请输入系统拉单笔数', trigger: 'blur' }]
            }
        }
    },
    created() {
        this.getList()
        this.merchantSelect()
        this.AccountTypeSelect()
    },
    watch: {
        'searchForm.merchantId': {
            handler(newVal, oldVal) {
                // 清空已选支付方式
                this.searchForm.accountType = ''
                // 触发获取支付方式列表
                this.AccountTypeSelect()
            },
            immediate: false
        }
    },
    computed: {
        // 将原始数据扁平化为每行显示两行（未付费用户/付费用户）
        flattenTableData() {
            const result = []
            this.tableData.forEach((item, index) => {
                // 未付费用户行
                result.push({
                    ...item,
                    rawData: item,
                    rowIndex: index,
                    isFirst: true,
                    userType: '未付费用户',
                    createWeight: item.createWeight,
                    successWeight: item.successWeight,
                    systemWeight: item.systemWeight,
                    missWeight: item.missWeight
                })
                // 付费用户行
                result.push({
                    ...item,
                    rawData: item,
                    rowIndex: index,
                    isFirst: false,
                    userType: '付费用户',
                    createWeight: item.payCreateWeight,
                    successWeight: item.paySuccessWeight,
                    systemWeight: item.paySystemWeight,
                    missWeight: item.payMissWeight
                })
            })
            return result
        }
    },
    methods: {
        getList() {
            this.loading = true
            // TODO: 调用API获取列表
            merchantApi.managePayPollingSearch({ content: { merchantId: this.searchForm.merchantId, accountType: this.searchForm.accountType } }).then((res) => {
                if (res.code == "0000") {
                    this.tableData = res.data
                }
                this.loading = false
            });
        },
        merchantSelect() {
            merchantApi.getMerchant({content:{currency:"RUB"}}).then((res) => {
                if (res.code == "0000") {
                    this.merchantList = res.data.rows;
                }
            });
        },
        AccountTypeSelect() {
            merchantApi.getAccountType({ merchantId: this.searchForm.merchantId }).then((res) => {
                if (res.code == "0000") {
                    this.accountTypeOptions = res.data
                }
            });
        },
        search() {
            this.getList()
        },
        handleAdd() {
            this.dialogTitle = '新增轮循配置'
            this.form = {
                id: null,
                merchantId: this.searchForm.merchantId,
                accountType: '',
                startAmount: 0,
                endAmount: 1000,
                dataRange: 100,
                calCd: 50,
                systemTime: 20,
                systemNum: 10,
                missRange: 0,
                createWeight: 0,
                successWeight: 0,
                systemWeight: 0,
                missWeight: 0,
                payCreateWeight: 0,
                paySuccessWeight: 0,
                paySystemWeight: 0,
                payMissWeight: 0,
                createBase: 0,
                successBase: 0
            }
            this.dialogVisible = true
        },
        handleChannelRankInit() {
            merchantApi.managePayPollingInitUpdate({ content: { merchantId: this.searchForm.merchantId, accountType: this.searchForm.accountType } }).then((res) => {
                if (res.code == "0000") {
                    this.$message.success('通道排名初始化成功')
                    this.getList()
                }
            });
        },
        handleEdit(row) {
            this.dialogTitle = '编辑轮循配置'
            this.form = { ...row }
            this.dialogVisible = true
        },
        handleSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    const apiName = this.form.id ? 'managePayPollingUpdate' : 'managePayPollingAdd'
                    merchantApi[apiName]({ content: this.form }).then((res) => {
                        if (res.code === '0000') {
                            this.$message.success(this.form.id ? '编辑成功' : '新增成功')
                            this.dialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                }
            })
        },
        handleToggleStatus(row) {
            const action = row.status === 1 ? '禁用' : '启用'
            this.$confirm(`确定要${action}该配置?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // TODO: 调用切换状态API
                this.$message.success('操作成功')
                this.getList()
            })
        },
        // 合并单元格方法
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            // 列索引对应：
            // 0-档位, 1-轮询数据范围配置, 2-轮询数据计算CD, 3-系统拉单时间, 4-系统拉单笔数, 5-掉单率范围
            // 6-订单拉起率(权重值), 7-订单成功率(权重值), 8-系统拉单成功率(权重值), 9-掉单率(权重值)
            // 10-订单拉起率(基准值), 11-订单成功率(基准值), 12-用户类型, 13-操作
            const mergeColumns = [0, 1, 2, 3, 4, 5, 10, 11, 13]
            if (mergeColumns.includes(columnIndex)) {
                if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            }
        },
        handleDelete(row) {
            this.$confirm('确定要删除该配置?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // TODO: 调用删除API
                merchantApi.managePayPollingUpdate({ content: { id: row.id, deleted: 1 } }).then((res) => {
                    if (res.code == "0000") {
                        this.$message.success('删除成功')
                        this.getList()
                    }
                });
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.pager {
    margin-top: 20px;
    text-align: right;
}
</style>
